module.exports = __webpack_public_path__ + "img/twitter.f741d79b.png";